
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/album/[albumUrlId]",
      function () {
        return require("private-next-pages/album/[albumUrlId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/album/[albumUrlId]"])
      });
    }
  